import "./DeleteResourceConfirmationModal.styles.scss";
import React from "react";
import { useTranslation } from "react-i18next";
import { Icon, Button } from "components";
import WarningIcon from "assets/icons/exclamation-triangle.svg";
import { useDeleteLibraryResource } from "utils/hooks";
import { LibraryResource, FileResource } from "types";
import {
  useOrganizationSettings,
  getPatientWordPlural,
} from "utils/hooks/organizations/useOrganizationSettings";

interface DeleteResourceConfirmationModalProps {
  resource: LibraryResource | FileResource | null;
  onCancel: () => void;
}

const DeleteResourceConfirmationModal = ({
  resource,
  onCancel,
}: DeleteResourceConfirmationModalProps) => {
  const { deleteLibraryResource } = useDeleteLibraryResource();
  const { t } = useTranslation(["common"]);
  const { settings } = useOrganizationSettings();

  return (
    <div className="resource-deletion-confirmation">
      <div className="resource-deletion-confirmation__icon">
        <Icon src={WarningIcon} alt="Warning Icon" />
      </div>
      <div className="resource-deletion-confirmation__title">
        Are you sure you want to delete this resource?
      </div>
      <div className="resource-deletion-confirmation__body">
        {t("resources.confirm_delete_resource", {
          patientWordPlural: getPatientWordPlural(settings),
        })}
      </div>
      <div className="resource-deletion-confirmation__buttons">
        <Button
          onClick={onCancel}
          name={`cancel_delete_resource_button`}
          value="Never mind"
          extraClass="secondary-bland"
          size="small"
        />
        <Button
          onClick={() => {
            deleteLibraryResource(resource);
            onCancel();
          }}
          name={`confirm_delete_resource_button`}
          value="Yes, delete it"
          extraClass="danger"
          size="small"
        />
      </div>
    </div>
  );
};

export default DeleteResourceConfirmationModal;
